import { camelize, camelizeKeys } from "humps";
import { AccessLevel, Profile } from "PFTypes";

type AllowedFieldNames = "booking_category";

type IsActivityFieldPermitted = {
  currentProfile: Profile;
  activityCreator: Profile | null;
  fieldName: AllowedFieldNames;
  accessLevel: AccessLevel;
};

export const isActivityFieldPermitted = ({
  currentProfile,
  activityCreator,
  fieldName,
  accessLevel = AccessLevel.ReadOnly
}: IsActivityFieldPermitted) => {
  const creatorPermissionsGroupId = camelizeKeys(activityCreator)?.permissionsGroup?.id;
  const currentProfilePermissionsGroupId = currentProfile.permissionsGroup.id;

  const { activityFieldsAccessLevels } =
    currentProfile.permissionsGroup.crossGroupPermissions[
      creatorPermissionsGroupId ?? currentProfilePermissionsGroupId
    ] || {};

  if (!activityFieldsAccessLevels) {
    return false;
  }

  const permission = activityFieldsAccessLevels[camelize(fieldName)];

  if (accessLevel === AccessLevel.ReadWrite) {
    return permission === AccessLevel.ReadWrite;
  } else if (accessLevel === AccessLevel.ReadOnly) {
    return permission === AccessLevel.ReadOnly || permission === AccessLevel.ReadWrite;
  }

  return false;
};
